import { get } from '@/utils/http'
import qs from 'qs'
import axios, { AxiosTransformer } from 'axios'
import { AccessTokenWrapper } from '@/models/session/token'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600 * 1000,
  headers: { 'Content-Type': 'application/json' }
})

const transformRequest: AxiosTransformer = (data, headers) => {
  const contentType = headers['Content-Type']
  if (typeof contentType !== 'string') return data

  const lower = contentType.toLocaleLowerCase()
  if (lower.includes('multipart/form-data')) return data
  if (lower.includes('application/json')) return JSON.stringify(data)
  return qs.stringify(data)
}
service.defaults.transformRequest = transformRequest
/**
 * 验证 Access Token 是否有效
 */
export async function CheckAccessToken() {
  await get('session/tokens')
}

/**
 * 刷新 Access Token
 * @param refreshToken
 */
export async function refreshAccessToken(refreshToken: string) {
  try {
    const { data } = await service.post('Session/tokens', refreshToken)
    return data as AccessTokenWrapper
  } catch (e) {
    return null
  }
}
